var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myVideo"},[_c('video',{staticClass:"video-js vjs-default-skin",staticStyle:{"border-radius":"6px"},attrs:{"id":`videoPlayer` + _vm.keyValue,"controls":"","playsinline":"","width":"500px","poster":_vm.poster}},[_c('source',{attrs:{"src":_vm.attachmentLink,"type":"application/x-mpegURL"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }